import type { ReactNode } from "react";
import styles from "./StatusBadge.module.css";

/**
 * Visual weight of a badge, mapped to a theme-token palette in the CSS module:
 *   - success: published / listed
 *   - neutral: not listed (a delisted or refused record)
 *   - warning: needs attention (today, an active-but-hidden opt-out)
 */
export type BadgeTone = "success" | "neutral" | "warning";

interface StatusBadgeProps {
  tone: BadgeTone;
  children: ReactNode;
}

/**
 * Small presentational pill for a record's status on the My Skills page. There is
 * no such component elsewhere because Contract 3 (`marketplace.json`) carries no
 * `status`; only the DynamoDB-backed my-records endpoint exposes one.
 */
export default function StatusBadge({ tone, children }: StatusBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {children}
    </span>
  );
}
